import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import { GetAuth } from '../../Auth/AuthProvider';

import { Box, Stack, Grid, Typography, Button } from '@mui/material';
import Logo from '../shared/Logo';

import { APIROOT } from '../../Helpers/configs';
import { useLocation, useNavigate } from 'react-router-dom';

import ICLRunningWarm from './ICLRunningWarm';
import ICLTrippingPower from './ICLTrippingPower';
import ICLRunningWarmWithCode from './ICLRunningWarmWithCode';
import ICLJupiterChecks from './ICLJupiterChecks';
import ICLVentoChecks from './ICLVentoChecks';
import ICLPaperWorkChecks from './ICLPaperWorkChecks';

import { viewBox } from '../shared/commonStyle';

import '../../Helpers/print.css';

const InstallCheckList = () => {
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;

  const [forceUpdate, setForceUpdate] = useState(1);
  const navigateNew = useNavigate();
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const location = useLocation();

  // const TicketId = location.state.install_ticket.id;

  const [ListData, setListData] = useState({
    rdm_running_warm_binFan:
      location.state.repair_checks.rdm_running_warm_binFan || '',
    rdm_running_warm_condensorDirty:
      location.state.repair_checks.rdm_running_warm_condensorDirty || '',
    rdm_running_warm_pressureLow:
      location.state.repair_checks.rdm_running_warm_pressureLow || '',

    rdm_tripping_power_fanInWater:
      location.state.repair_checks.rdm_tripping_power_fanInWater || '',
    rdm_tripping_power_condensorSeized:
      location.state.repair_checks.rdm_tripping_power_condensorSeized || '',
    rdm_tripping_power_compressorEarth:
      location.state.repair_checks.rdm_tripping_power_compressorEarth || '',
    rdm_tripping_power_heatersWorking:
      location.state.repair_checks.rdm_tripping_power_heatersWorking || '',
    rdm_tripping_power_electricalComponents:
      location.state.repair_checks.rdm_tripping_power_electricalComponents ||
      '',

    lng_running_warm_binFan:
      location.state.repair_checks.lng_running_warm_binFan || '',
    lng_running_warm_condensorDirty:
      location.state.repair_checks.lng_running_warm_condensorDirty || '',
    lng_running_warm_pressureLow:
      location.state.repair_checks.lng_running_warm_pressureLow || '',

    lng_tripping_power_fanInWater:
      location.state.repair_checks.lng_tripping_power_fanInWater || '',
    lng_tripping_power_condensorSeized:
      location.state.repair_checks.lng_tripping_power_condensorSeized || '',
    lng_tripping_power_compressorEarth:
      location.state.repair_checks.lng_tripping_power_compressorEarth || '',
    lng_tripping_power_heatersWorking:
      location.state.repair_checks.lng_tripping_power_heatersWorking || '',
    lng_tripping_power_electricalComponents:
      location.state.repair_checks.lng_tripping_power_electricalComponents ||
      '',

    paris_running_warm_incommingPower:
      location.state.repair_checks.paris_running_warm_incommingPower || '',

    paris_running_warm_E20lidsOpen:
      location.state.repair_checks.paris_running_warm_E20lidsOpen || '',
    paris_running_warm_E20condensorBlocked:
      location.state.repair_checks.paris_running_warm_E20condensorBlocked || '',
    paris_running_warm_E20gasLeak:
      location.state.repair_checks.paris_running_warm_E20gasLeak || '',

    paris_running_warm_E75fanRunning:
      location.state.repair_checks.paris_running_warm_E75fanRunning || '',

    paris_running_warm_E80checkCompressor:
      location.state.repair_checks.paris_running_warm_E80checkCompressor || '',
    paris_running_warm_E80checkMotherboard:
      location.state.repair_checks.paris_running_warm_E80checkMotherboard || '',

    jupiter_checks_components:
      location.state.repair_checks.jupiter_checks_components || '',
    jupiter_checks_probes:
      location.state.repair_checks.jupiter_checks_probes || '',
    jupiter_checks_switches:
      location.state.repair_checks.jupiter_checks_switches || '',
    jupiter_checks_pressure:
      location.state.repair_checks.jupiter_checks_pressure || '',
    jupiter_checks_WHS: location.state.repair_checks.jupiter_checks_WHS || '',

    vento_checks_params: location.state.repair_checks.vento_checks_params || '',

    pw_checks_jcSigned: location.state.repair_checks.pw_checks_jcSigned || '',
    pw_checks_soSigned: location.state.repair_checks.pw_checks_soSigned || '',
    pw_checks_grnIssued: location.state.repair_checks.pw_checks_grnIssued || '',
    pw_checks_gasUsage: location.state.repair_checks.pw_checks_gasUsage || '',
    pw_checks_hotWorks: location.state.repair_checks.pw_checks_hotWorks || '',
    pw_checks_coc: location.state.repair_checks.pw_checks_coc || '',
  });

  const handleChange = (val, item) => {
    // console.log(item, val);
    setListData({ ...ListData, [item]: val });
  };

  const combineData = () => {
    console.log(ListData);
    let ticketBlob = {
      repair_ticket: {
        // ticket_type: location.state.install_ticket.ticket_type,
        // customer_id: location.state.install_ticket.customer_id,
        // status: location.state.install_ticket.status,
      },
      repair_checks: ListData,
    };

    return ticketBlob;
  };

  const ticketUpdate = () => {
    const DataBlob = { ...combineData() };
    // console.log('DATA BLOB', DataBlob);
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = DataBlob;
    const request = new Request(
      `${APIROOT}/api/r2_repair_tickets/${location.state.repair_ticket.id}`,
      {
        method: 'post',
        headers,
        body: JSON.stringify(body),
      }
    );
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save ticket`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          //Update JWT if required
          // console.log(
          //   'here with path',
          //   `${APIROOT}/api/repair-tickets/${location.state.id}`
          // );
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
          navigateNew(`/tech/tech_ticket_view/checkSheet`, {
            replace: true,
            state: location.state,
          });
          enqNotification('Saved successfully', 'success');
          setForceUpdate(forceUpdate + 1);
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : `Connection Error !! ${error}`,
          'error'
        );
      });
  };

  return (
    <Box sx={viewBox}>
      <Stack
        spacing={2}
        padding='15px'
        ref={componentRef}
        className='main-style'
      >
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <Grid item xs={12} md={12}>
            <Logo />
          </Grid>
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              TROUBLE SHOOTING
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='p-print-avoid-break'
        >
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              RDMs
            </Typography>
          </Grid>
          <ICLRunningWarm
            data={{
              binFan: ListData.rdm_running_warm_binFan,
              condensorDirty: ListData.rdm_running_warm_condensorDirty,
              pressureLow: ListData.rdm_running_warm_pressureLow,
            }}
            handleChange={(val, item) =>
              handleChange(val, `rdm_running_warm_${item}`)
            }
          />
          <ICLTrippingPower
            data={{
              fanInWater: ListData.rdm_tripping_power_fanInWater,
              condensorSeized: ListData.rdm_tripping_power_condensorSeized,
              compressorEarth: ListData.rdm_tripping_power_compressorEarth,
              heatersWorking: ListData.rdm_tripping_power_heatersWorking,
              electricalComponents:
                ListData.rdm_tripping_power_electricalComponents,
            }}
            handleChange={(val, item) =>
              handleChange(val, `rdm_tripping_power_${item}`)
            }
          />
        </Grid>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='p-print-avoid-break'
        >
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              LNGs
            </Typography>
          </Grid>
          <ICLRunningWarm
            data={{
              binFan: ListData.lng_running_warm_binFan,
              condensorDirty: ListData.lng_running_warm_condensorDirty,
              pressureLow: ListData.lng_running_warm_pressureLow,
            }}
            handleChange={(val, item) =>
              handleChange(val, `lng_running_warm_${item}`)
            }
          />
          <ICLTrippingPower
            data={{
              fanInWater: ListData.lng_tripping_power_fanInWater,
              condensorSeized: ListData.lng_tripping_power_condensorSeized,
              compressorEarth: ListData.lng_tripping_power_compressorEarth,
              heatersWorking: ListData.lng_tripping_power_heatersWorking,
              electricalComponents:
                ListData.lng_tripping_power_electricalComponents,
            }}
            handleChange={(val, item) =>
              handleChange(val, `lng_tripping_power_${item}`)
            }
          />
        </Grid>

        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='p-print-avoid-break'
        >
          {' '}
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              PARIS
            </Typography>
            <ICLRunningWarmWithCode
              data={{
                incommingPower: ListData.paris_running_warm_incommingPower,
                E20lidsOpen: ListData.paris_running_warm_E20lidsOpen,
                E20condensorBlocked:
                  ListData.paris_running_warm_E20condensorBlocked,
                E20gasLeak: ListData.paris_running_warm_E20gasLeak,
                E75fanRunning: ListData.paris_running_warm_E75fanRunning,
                E80checkCompressor:
                  ListData.paris_running_warm_E80checkCompressor,
                E80checkMotherboard:
                  ListData.paris_running_warm_E80checkMotherboard,
              }}
              handleChange={(val, item) =>
                handleChange(val, `paris_running_warm_${item}`)
              }
            />
          </Grid>
        </Grid>

        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='p-print-avoid-break'
        >
          {' '}
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              JUPITER
            </Typography>
            <ICLJupiterChecks
              data={{
                components: ListData.jupiter_checks_components,
                probes: ListData.jupiter_checks_probes,
                switches: ListData.jupiter_checks_switches,
                pressure: ListData.jupiter_checks_pressure,
                WHS: ListData.jupiter_checks_WHS,
              }}
              handleChange={(val, item) =>
                handleChange(val, `jupiter_checks_${item}`)
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='p-print-avoid-break'
        >
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              VENTO
            </Typography>
            <ICLVentoChecks
              data={{ params: ListData.vento_checks_params }}
              handleChange={(val, item) =>
                handleChange(val, `vento_checks_${item}`)
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
          className='p-print-avoid-break'
        >
          <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
            <Typography variant='h6' fontWeight='700' fontSize={24}>
              If other Multilayer trading cabinets in store, please check all in
              order.
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
            <Typography variant='h6' fontWeight='700' fontSize={28}>
              PAPERWORK CHECKS
            </Typography>
            <ICLPaperWorkChecks
              data={{
                jcSigned: ListData.pw_checks_jcSigned,
                soSigned: ListData.pw_checks_soSigned,
                grnIssued: ListData.pw_checks_grnIssued,
                gasUsage: ListData.pw_checks_gasUsage,
                hotWorks: ListData.pw_checks_hotWorks,
                coc: ListData.pw_checks_coc,
              }}
              handleChange={(val, item) =>
                handleChange(val, `pw_checks_${item}`)
              }
            />
          </Grid>
        </Grid>
      </Stack>
      <Box sx={{ float: 'right' }}>
        <Button
          variant='contained'
          onClick={() => {
            ticketUpdate();
          }}
          // onClick={
          //   handleSave
          //   // console.table(TicketId);
          //   // ticketUpdate();
          // }
          sx={{ margin: '15px 0 0 15px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          sx={{ margin: '15px 0 0 15px' }}
          onClick={handlePrint}
        >
          Print
        </Button>

        <Button
          onClick={() =>
            navigateNew(`/tech/tech_repair_ticket_view`, {
              replace: true,
              state: location.state.repair_ticket,
            })
          }
          variant='contained'
          sx={{ margin: '15px 0 0 15px' }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default InstallCheckList;
